import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1626c436"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "icp-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text" }, "ICP备案/许可证号：粤ICP备2023084621号-1", -1))
const _hoisted_3 = { class: "text" }

import DisclaimerPop from './DisclaimerPop.vue';

import { ref } from "vue";
const company = "深圳壹启智控科技有限公司"

export default /*#__PURE__*/_defineComponent({
  __name: 'IcpComp',
  setup(__props) {

const appName = ref<string>(APP_NAME);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", _hoisted_3, _toDisplayString(appName.value) + "-" + _toDisplayString(company), 1),
    _createVNode(DisclaimerPop, { company: company })
  ]))
}
}

})